class MegaMenuContent extends HTMLElement {
  constructor() {
    super();

    this.images = [];
    this.triggers = this.querySelectorAll(`.mega-menu__link:not(.mega-menu__link--level-2)`);

    const dynamicBlock = this.querySelector('[megamenu-block-dynamic]');
    if( dynamicBlock === null ) {
      return;
    }

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseover', (event) => {
        event.preventDefault();
        const title = trigger.innerHTML;
        const link = trigger.getAttribute('href');
        const imageUrl = trigger.getAttribute('data-image-url');
        dynamicBlock.querySelector('.card > .card__content .card__heading > a').setAttribute('href', link);
        dynamicBlock.querySelector('.card > .card__content .card__heading > a').innerHTML = title;
        dynamicBlock.querySelector('.card > .card__content .card__description').style.display = 'none';
        dynamicBlock.querySelector('.card .card__media .media').innerHTML = `<img src="${imageUrl}" alt="${title}" />`;
      });
    });

    window.onload = this.preloadImages(this.triggers, this.images);
  }

  preloadImages(triggers, images) {
    // Preload:  https://stackoverflow.com/questions/3646036/preloading-images-with-javascript
    triggers.forEach((trigger) => {
      const imageUrl = trigger.getAttribute('data-image-url');
      let image = new Image();
      image.src = imageUrl;
      images.push( image );
    });
  }
}

customElements.define('mega-menu-content', MegaMenuContent);
